import { action } from 'typesafe-actions';

import { IKnmAttachment } from 'APIPackage/KnmModule/interfaces/IKnmAttachment';
import { TableCheckItems } from 'CorePackage/MainModule/types/TableCheckItems';

import { KnmDocumentsActionsEnum } from '../enums/KnmDocumentsActionsEnum';
import { IKnmAttachmentDocument } from '../interfaces/IKnmAttachmentDocument';
import { IKnmAttachmentWithType } from '../interfaces/IKnmAttachmentWithType';

// eslint-disable-next-line @typescript-eslint/naming-convention
interface CommonFormApi {
  getFieldState: (field: string) => { value?: unknown } | undefined;
  change: (field: string, value: unknown) => void;
}

export const knmDocumentsUpload = (
  document: File | null,
  signs: File[],
  onSaveSignedDocument: (document: File, signatureInfo: IKnmAttachment['signatureInfo']) => void,
) => action(KnmDocumentsActionsEnum.KNM_DOCUMENTS_UPLOAD, { document, signs, onSaveSignedDocument });
export const knmDocumentsSaveSignedDocument = (
  form: CommonFormApi | undefined,
  signedDocument: File,
  signatureInfo: IKnmAttachment['signatureInfo'],
  formFieldName: string | null,
  addAttachment: (fieldName: string, data: IKnmAttachmentDocument) => void,
) =>
  action(KnmDocumentsActionsEnum.KNM_DOCUMENTS_SAVE_SIGNED_DOCUMENT, {
    form,
    signedDocument,
    signatureInfo,
    formFieldName,
    addAttachment,
  });
export const knmDocumentsDownload = (documents: IKnmAttachmentWithType[], itemsCheck: TableCheckItems) =>
  action(KnmDocumentsActionsEnum.KNM_DOCUMENTS_DOWNLOAD, { documents, itemsCheck });
